
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function dm_c_03_stats() {

    const els = document.querySelectorAll('section.c-03-stats .number');

    els.forEach((el) => {
        const target = parseFloat(el.dataset.target ?? el.textContent.replace(/[^\d.-]/g, '')); 
        
        if (!isFinite(target)) return;

        const isInt = Number.isInteger(target); 
        const obj = { val: 0 }; 
        const dur = parseFloat(el.dataset.duration || '1.2');

        // format helper 
        const fmt = (v) => (isInt ? Math.round(v) : Math.round(v * 100) / 100).toLocaleString();

        // ensure initial text 
        el.textContent = fmt(0);

        ScrollTrigger.create({
            trigger: el, start: 'top 75%',
            onEnter: () => {
                gsap.to(obj, 
                    { 
                        val: target, 
                        duration: dur, 
                        ease: 'power1.out', 
                        onUpdate: () => { 
                            el.textContent = fmt(obj.val); 
                        }, 
                    });
            },
        });
    });

}

export { dm_c_03_stats };